import React from 'react';
import PropTypes from 'prop-types';
import { ONBOARDING_STEP } from '../../constants';
import ElementTransition from '../ElementTransition';
import RegistrationForm from '../RegistrationForm';
import LoginForm from '../LoginForm';
import Plan from '../Plans';
import Payment from '../Payment';
import ConfirmAccountForm from '../ConfirmAccountForm';
import ForgotPasswordForm from '../ForgotPasswordForm';
import ResetPasswordForm from '../ResetPasswordForm';

class Onboarding extends React.PureComponent {
  static propTypes = {
    onGoToRegister: PropTypes.func,
    onAfterConfirmAccount: PropTypes.func,
    onForgotPassword: PropTypes.func,
    onAfterLogin: PropTypes.func,
    onAfterSendResetCode: PropTypes.func,
    onAfterSetPassword: PropTypes.func,
    onRegister: PropTypes.func,
    onGoToLogin: PropTypes.func,
    registrationError: PropTypes.string,
    registrationMessage: PropTypes.string,
    chosenPlan: PropTypes.object,
    activePlan: PropTypes.object,
    couponCode: PropTypes.string,
    couponError: PropTypes.string,
    paymentError: PropTypes.string,
    planSummary: PropTypes.object,
    step: PropTypes.string,
    onGoToPlan: PropTypes.func,
    onChangeCoupon: PropTypes.func,
    onChangePlan: PropTypes.func,
    onConfirmPlan: PropTypes.func,
    onCreateSubscription: PropTypes.func,
  };
  static defaultProps = {};

  render() {
    const {
      onGoToRegister,
      onAfterConfirmAccount,
      onForgotPassword,
      onAfterLogin,
      onAfterSendResetCode,
      onAfterSetPassword,
      onRegister,
      onGoToLogin,
      registrationError,
      registrationMessage,
      chosenPlan,
      activePlan,
      couponCode,
      couponError,
      paymentError,
      planSummary,
      step,
      onGoToPlan,
      onChangePlan,
      onChangeCoupon,
      onConfirmPlan,
      onCreateSubscription,
      ...otherProps
    } = this.props;

    const registrationProps = {
      onRegister: onRegister,
      onGoToLogin: onGoToLogin,
      error: registrationError,
      message: registrationMessage,
    };
    const confirmAccountProps = {
      onAfterConfirmAccount: onAfterConfirmAccount,
    };
    const loginProps = {
      onGoToRegister: onGoToRegister,
      onForgotPassword: onForgotPassword,
      onAfterLogin: onAfterLogin,
    };
    const forgotPasswordProps = {
      onAfterSendResetCode: onAfterSendResetCode,
      onCancel: onGoToLogin,
    };
    const resetPasswordProps = {
      onAfterSetPassword: onAfterSetPassword,
    };
    const planProps = {
      chosenPlan: chosenPlan,
      activePlan: activePlan,
      onChangePlan: onChangePlan,
      onConfirmPlan: onConfirmPlan,
    };
    const paymentProps = {
      chosenPlan: chosenPlan,
      couponCode: couponCode,
      couponError: couponError,
      paymentError: paymentError,
      planSummary: planSummary,
      onGoToPlan: onGoToPlan,
      onChangeCoupon: onChangeCoupon,
      onCreateSubscription: onCreateSubscription,
    };

    let activeItem;
    switch (step) {
      case ONBOARDING_STEP.REGISTER:
        activeItem = {
          id: 'registration',
          element: <RegistrationForm {...registrationProps} />,
        };
        break;
      case ONBOARDING_STEP.CONFIRM:
        activeItem = {
          id: 'confirmAccount',
          element: <ConfirmAccountForm {...confirmAccountProps} />,
        };
        break;
      case ONBOARDING_STEP.LOGIN:
        activeItem = {
          id: 'login',
          element: <LoginForm {...loginProps} />,
        };
        break;
      case ONBOARDING_STEP.FORGOT_PASSWORD:
        activeItem = {
          id: 'forgotPassword',
          element: <ForgotPasswordForm {...forgotPasswordProps} />,
        };
        break;
      case ONBOARDING_STEP.RESET_PASSWORD:
        activeItem = {
          id: 'resetPassword',
          element: <ResetPasswordForm {...resetPasswordProps} />,
        };
        break;
      case ONBOARDING_STEP.PLAN:
        activeItem = {
          id: 'plan',
          element: <Plan {...planProps} />,
        };
        break;
      case ONBOARDING_STEP.PAY:
        activeItem = {
          id: 'payment',
          element: <Payment {...paymentProps} />,
        };
        break;
      default:
        activeItem = { id: 'nothing', element: null };
        break;
    }

    return <ElementTransition {...activeItem} />;
  }
}

export default Onboarding;



// WEBPACK FOOTER //
// ./src/components/Onboarding/Onboarding.js